
import React from 'react';
import { Job } from "@/components/jobs/types";
import { Button } from "@/components/ui/button";
import { FileText, Link as LinkIcon } from "lucide-react";

interface JobOverviewDocumentsProps {
  job: Job;
  isEditing: boolean; // Kept for consistency, though not used for editability here
}

export const JobOverviewDocuments: React.FC<JobOverviewDocumentsProps> = ({
  job,
  isEditing
}) => {
  if (isEditing || (!job.document_url && !job.source_url)) {
    return null; // Don't show documents section if editing or no documents
  }

  return (
    <div className="mt-4 border-t pt-4">
      <h3 className="text-sm font-medium mb-2">Job Documents</h3>
      <div className="flex flex-wrap gap-2">
        {job.document_url && (
          <Button variant="outline" size="sm" asChild>
            <a href={job.document_url} target="_blank" rel="noopener noreferrer" className="flex items-center">
              <FileText className="h-4 w-4 mr-2" />
              View PDF
            </a>
          </Button>
        )}
        {job.source_url && (
          <Button variant="outline" size="sm" asChild>
            <a href={job.source_url} target="_blank" rel="noopener noreferrer" className="flex items-center">
              <LinkIcon className="h-4 w-4 mr-2" />
              Original Posting
            </a>
          </Button>
        )}
      </div>
    </div>
  );
};
